import { getRoutesDirections } from '@/data/libraries/RoutesTranslated';

import { useLocation } from 'react-router-dom';

import lastPageName from '@/domain/utils/lastPageName';
import { translate } from '@/domain/utils/translate';
import PasswordUserForm from '@/ui/components/user/PasswordUserForm';

import UserOptionsContainer from '@/ui/containers/userOptions/UserOptionsContainer';
import { useEffect } from 'react';

/**
 * Componente UserPassword
 * 
 * Este componente representa la página de cambio de contraseña del usuario.
 * Utiliza el componente `UserOptionsContainer` para envolver el formulario de cambio de contraseña (`PasswordUserForm`).
 * También genera una lista de migas de pan (breadcrumbs) para la navegación.
 * 
 * @returns {JSX.Element} El componente UserPassword.
 */
const UserPassword = (): JSX.Element => {
  // Obtiene la ubicación actual de la ruta
  const location = useLocation();

  /** Rutas URLs */
  const routesDirections = getRoutesDirections();
  // Define las migas de pan para la navegación
  const breadcumbs = [
    { label: translate('breadcrumbs.home'), url: routesDirections.MAIN_ROUTE },
    { label: lastPageName(location.pathname), url: location.pathname }
  ];

  // Hacer scroll al tope al montar el componente
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <UserOptionsContainer breadcumbsList={breadcumbs} type='content-password'>
      <PasswordUserForm />
    </UserOptionsContainer>
  );
};

export default UserPassword;
